import BaseFeature from '../../foundation/base/base';

class ProductDynamicPrice extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.log('ProductDynamicPrice Feature Init');
		this.prices = JSON.parse(this.el.dataset.prices);
		this.quantity = this.el.querySelector('[data-js="product-dynamic-price__quantity"]');
		this.priceExclVat = this.el.querySelector('[data-js="product-dynamic-price__priceExclVat"]');
		this.priceInclVat = this.el.querySelector('[data-js="product-dynamic-price__priceInclVat"]');
		this.message = this.el.querySelector('[data-js="product-dynamic-price__message"]');
		this.action = this.el.querySelector('[data-js="product-dynamic-price__action"]');

		this.activeClass = 'is-active';

		this.init();
	}

	init() {
		this.publishInitPrice();

		let quantity = this.quantity.value;
		let priceObj = this.getPrice(quantity);
		this.renderPrice(priceObj);
		this.publishPrice(priceObj);

		this.quantity.addEventListener('change', (e) => {
			this.log('change');
			quantity = e.currentTarget.value;
			priceObj = this.getPrice(quantity);
			this.renderPrice(priceObj);
			this.publishPrice(priceObj);
		});
	}

	getPrice(quantity) {
		const { prices } = this;

		const priceObj = prices.find(item => parseInt(item.quantity, 10) === parseInt(quantity, 10));
		return priceObj;
	}

	renderPrice(priceObj) {
		const {
			quantity,
			priceExclVatDisplayText,
			priceInclVatDisplayText
		} = priceObj;

		this.priceExclVat.innerHTML = priceExclVatDisplayText;
		this.priceInclVat.innerHTML = priceInclVatDisplayText;

		if (quantity >= 50) {
			this.message.classList.add(this.activeClass);
			this.action.setAttribute('disabled', '');
		} else {
			this.message.classList.remove(this.activeClass);
			this.action.removeAttribute('disabled');
		}
	}

	publishPrice(priceObj) {
		this.publish('dynamicPrice.change', priceObj);
	}

	publishInitPrice() {
		window.addEventListener('load', () => {
			/**
				Delay the publish until page is done so all components
				will receive the message
			 */
			this.publish('dynamicPrice.init', true);
		});
	}
}

export default ProductDynamicPrice;
